/**
 * Gets the user's locale from navigator
 */
export function getUserLocale(): string | undefined {
  if (typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language;
  }
  return undefined;
}
